import React from "react";
import PropTypes from "prop-types";
import { Link } from "@/helpers/router";
import { Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const RESOURCE_TO_PATH = {
  ptab: "/ptab/caselist",
  litigation: "/litigation/caselist",
  exparte: "/exparte/search"
};

const RESOURCE_TO_TITLE = {
  ptab: "PTAB",
  litigation: "Litigation",
  exparte: "Ex Parte"
};

const ResourceSearchLink = props => {
  const { value, index, resource } = props;
  const target = {
    pathname: RESOURCE_TO_PATH[resource],
    query: {
      [index]: value
    }
  };
  const styleIcon = {
    marginLeft: 4
  };
  return (
    <Tooltip title={`Search ${RESOURCE_TO_TITLE[resource]} Cases`}>
      <Link to={target} style={styleIcon}>
        <SearchOutlined />
      </Link>
    </Tooltip>
  );
};

ResourceSearchLink.propTypes = {
  value: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
  resource: PropTypes.oneOf(["ptab", "litigation", "exparte"]).isRequired
};

export default ResourceSearchLink;
